export default {
  namespaced: true,
  state: {
    loading: [],
    isLongDurationLoad: false
  },
  getters: {
    isLoading: (state) => {
      return state.loading.length !== 0 && state.isLongDurationLoad
    }
  },
  mutations: {
    setLoading (state, id) {
      if (state.loading.indexOf(id) === -1) {
        state.loading.push(id)
      }
    },

    unsetLoading (state, id) {
      const index = state.loading.indexOf(id)
      if (index !== -1) {
        state.loading.splice(index)
      }
    },

    setIsLongDurationLoad (state) {
      state.isLongDurationLoad = state.loading.length > 0
    }
  },
  actions: {
    setLoading ({ commit }, id) {
      commit('setLoading', id)

      // Wait before actually showing the progress bar
      setTimeout(() => {
        commit('setIsLongDurationLoad')
      }, 1000)
    },

    unsetLoading ({ commit }, id) {
      commit('unsetLoading', id)
      commit('setIsLongDurationLoad')
    }
  }
}
